import { db } from "../../firebase";
import {
	collection,
	doc,
	query,
	addDoc,
	setDoc,
	updateDoc,
	getDoc,
	getDocs,
	orderBy,
	where,
	Timestamp,
	deleteDoc as deleteFirestoreDoc
} from "firebase/firestore";
import { v4 as uuidv4 } from "uuid";

interface SongShareType {
	audio_url?: string;
	id?: string;
	comments: string;
	created?: Timestamp;
	css_class?: string;
	plays: number;
	song_name?: string;
	wave_color?: string;
	user_id?: string;
}

export const viewRecord = async (recordId: string): Promise<SongShareType | null> => {
	try {
		const docRef = doc(db, "shares", recordId);
		const docSnap = await getDoc(docRef);

		if (docSnap.exists()) {
			const data = docSnap.data() as SongShareType;
			const createdDate = data.created ? getFormattedDate(data.created) : null;
			return {
				audio_url: data.audio_url,
				id: docSnap.id,
				comments: data.comments,
				created: createdDate,
				css_class: data.css_class,
				plays: data.plays,
				song_name: data.song_name,
				wave_color: data.wave_color,
				user_id: data.user_id
			};
		} else {
			throw new Error("Unable to get song share data");
		}
	} catch (error) {
		console.error("Error getting song share: ", error);
		return null;
	}
};

export const addRecord = async (currentUser, newRecord: SongShareType) => {
	try {
		newRecord.user_id = currentUser.uid;
		const shareId = uuidv4();
		const docRef = doc(db, "shares", shareId);
		await setDoc(docRef, newRecord);
		return shareId;
	} catch (error) {
		console.error("Error adding user: ", error);
	}
};

export const getFormattedDate = (date: Timestamp | string | undefined): string => {
	if (!date) return "";
	const dateObj = typeof date === "string" ? new Date(date) : date.toDate();
	return dateObj.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" }) + " " + dateObj.toLocaleDateString("en-US");
};
